import { render, staticRenderFns } from "./EcHeader.vue?vue&type=template&id=e389797e&"
import script from "./EcHeader.vue?vue&type=script&lang=ts&"
export * from "./EcHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports